import loadable from '@loadable/component';

export const LazyContactCollectorIframe = loadable(() => import(/* webpackChunkName: "content/contactCollector/iframe" */ '.'));
